import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { asyncScheduler, fromEvent, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import * as Models from '../../models';
import { SOTService } from '../../services';
import { SOTRecipeLinkingViewModel, SOTProductViewModel } from '../../models';
import Utils from '../../../core/shared/utils';

@Component({
  selector: "sot-recipelink",
  templateUrl: "./recipelink.component.html",
  styleUrls: ["./recipelink.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipeLinkComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("product_list") product_list_div: ElementRef;

  private _productScrollSubscription: Subscription;
  /** callback der aufgerufen wird, wenn die bearbeitung abgeschloßen wird */
  private _callback: () => void;
  private _selectedTags: number[];

  public product: SOTRecipeLinkingViewModel;
  public itemgroup: Models.SOTItemGroupViewModel;
  public isItemTagEnabled: boolean = false;
  public shouldOpenProduct: boolean = true;
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;
  public show_product_list_bottom_scroll: boolean;
  public extra: SOTProductViewModel;
  public subextra: SOTProductViewModel;


  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
    console.debug("--- sot-recipelink constructor")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("RecipeLinkComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public ngOnInit(): void {
    console.debug("--- sot-recipelink ngOnInit")
    const me = this;
    me.show_product_list_bottom_scroll = false;
    me.itemTagSettings();
    me.isModeOne = me._sotService.useModeOne();
    me.isModeTwo = me._sotService.useModeTwo();
    const navigation_state = me._sotService.GetAndClearProductComponentBuffer();
    if (navigation_state.product instanceof SOTRecipeLinkingViewModel) {
      me.itemgroup = navigation_state.itemGroup;
      me.product = navigation_state.product;
    } else {
      console.error(`ProductComponent ngOnInit unknown type of navigation_state.product`, navigation_state.product);
    }
    me._callback = navigation_state.callback;
    me._selectedTags = this._sotService.GetProductTagFilter();

    me.PushChanges();
  }

  public ngAfterViewInit(): void {
    console.debug("--- sot-recipelink ngAfterViewInit")
    const me = this;
    // after view init, da dann die höhe bekannt ist
    const product_list_el = me.product_list_div.nativeElement;
    if (product_list_el.scrollHeight > product_list_el.offsetHeight) {
      me.show_product_list_bottom_scroll = true; // show bottom scroll initial
      me.PushChanges();

      // Subscribe to a throttled scrollEvent from ProductList
      me._productScrollSubscription = fromEvent(me.product_list_div.nativeElement, "scroll").pipe(
        throttleTime(50, asyncScheduler, { leading: true, trailing: true }),
      ).subscribe(() => {
        // toggles show_product_list_bottom_scroll when scrolled to the bottom or not
        const at_bottom = (product_list_el.scrollTop + product_list_el.offsetHeight) >= (product_list_el.scrollHeight - 5 /*5=bottom_offset*/);
        if (at_bottom === me.show_product_list_bottom_scroll) {
          me.show_product_list_bottom_scroll = !at_bottom;
          me.PushChanges();
        }
      });
    }
    if (me._sotService.shouldOpenProduct) {
      // Springe in den aktiven Artikel, wenn nur einer vorhanden ist.
      const sotProducts = me.product.sotProducts.filter((product) => product.schedule.active && product.is_available);
      if (sotProducts.length === 1) {
        me.openProduct(sotProducts[0]);
        me._sotService.shouldNavigateToMenu = true;
        return;
      }
    }
  }

  public back(): void {
    this._callback();
  }

  public showProductInfo(product): void {
    this._sotService.OpenProductDialog(product, true, () => { });
  }

  /**
   * Navigates to a products page if it is available
   * @param recipeProduct ProductViewModel
   */

  public openProduct(sotProduct: SOTProductViewModel): void {
    const me = this;
    if (sotProduct.schedule.active && sotProduct.is_available) {
      me._sotService.OpenProduct(sotProduct, me.itemgroup, me.product, me._callback);
    }
  }

  /** item tag settings*/
  public async itemTagSettings() {
    const me = this;
    await me._sotService.getWebshopSettingsDataModel().then((webshopSettings) => {
      if (webshopSettings) {
        me.isItemTagEnabled = webshopSettings.is_itemtag_sot_enabled;// tags am SOT aktiv
        me.PushChanges();
      }
    });
  }

  /** product tags
   * only first five tags will be displayed*/
  public GetProductTagsById(tagIds: number[]) {
    const me = this;
    return me._sotService.GetProductTagsByIds(tagIds).slice(0, 5)
  }

  public get hasTagFilterSelected(): boolean {
    const me = this;
    return me._selectedTags != null ? me._selectedTags.length > 0 : false;
  }

  public hasContent(content: string): boolean {
    return !Utils.IsNullOrEmpty(content);
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-recipelink ngOnDestroy")
    const me = this;
    if (me._productScrollSubscription) {
      me._productScrollSubscription.unsubscribe();
    }
  }
}
